import { PageTitleComponent } from '@app/shared/components/page-title/page-title.component';
import { inject, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModulesService } from '@shared/services/modules.service';
import { Router } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';

/**
 * Menú del módulo Soporte. Mismo tarjetón que Reportes y Catálogos.
 *
 * Son dos opciones fijas (no dependen del rol ni de un search), así que se
 * declaran aquí igual que `REPORT_CARDS`:
 *   · Soporte             → levantar y dar seguimiento a tickets.
 *   · Manual de usuarios  → PDF y videos del manual, por rol.
 */
const SUPPORT_CARDS: card[] = [
  {
    title: 'Soporte',
    description: 'Levanta un ticket cuando algo falla y dale seguimiento hasta que quede resuelto.',
    icon: 'confirmation_number',
    route: 'tickets'
  },
  {
    title: 'Manual de usuarios',
    description: 'Manual en PDF y videos de capacitación por módulo, según tu rol.',
    icon: 'menu_book',
    route: 'manuals'
  },
];

export interface card {
  title: String,
  description: String,
  icon: String,
  route: String
}

@Component({
  standalone: true,
  imports: [PageTitleComponent, FormsModule, ReactiveFormsModule, MaterialModule],
  selector: 'app-support-menu',
  templateUrl: './support-menu.component.html',
  styleUrls: ['./support-menu.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class SupportMenuComponent implements OnInit {
  private modulesSvcTitle = inject(ModulesService);
  /** Título del módulo = etiqueta visible del catálogo de Módulos. */
  title = this.modulesSvcTitle.moduleTitle('/support', 'Soporte');


  menuCards: card[] = [];

  constructor(private router: Router) { }

  ngOnInit() {
    this.menuCards = SUPPORT_CARDS;
  }

  /** @description Navegación a las pantallas hijas. */
  navigationTo(route: String) {
    this.router.navigate(['/support/' + route]);
  }
}
